import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './components/Header';
import DepositWithdrawBar from './components/DepositWithdrawBar';
import { PromoMarquee } from '@/components/common/PromoMarquee';
import BottomNav from './components/BottomNav';
import { Footer } from './components/Footer';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { closeMyBetsModal } from '@/store/slices/currentBetCountSlice';
import { FloatingMyBetsButton } from './components/FloatingMyBetsButton';
import MyBetsModal from '@/pages/MyBetsModal';
import { useGetPendingBetsCountQuery } from '@/store/api/betReportApi';
import MobileScrollTopButton from './components/MobileScrollTopButton';
import { useGetStakeSetQuery } from '@/store/api/stakesApi';
import { useGetUnreadMessageCountQuery } from '@/store/api/userMessagesApi';
import { useIsAuthenticated } from '@/hooks/redux';
import { useCurrencySymbol } from '@/hooks/useCurrencySymbol';

export const layoutConfig = {
  showPromoMarquee: ['/sports'],
  showBottomNav: ['/casino', '/sports', '/messages'],
};

const isMatchingRoute = (pathname: string, routes: string[]) =>
  routes.some((route) => pathname === route || (route !== '/' && pathname.startsWith(`${route}/`)));

function AppLayoutWithBottomNav() {
  const isAuthenticated = useIsAuthenticated();
  useGetPendingBetsCountQuery();
  useGetStakeSetQuery();
  useCurrencySymbol();
  useGetUnreadMessageCountQuery(undefined, { skip: !isAuthenticated, pollingInterval: 15000 });
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const isMyBetsModalOpen = useAppSelector((state) => state.currentBetCount.isMyBetsModalOpen);

  const showPromoMarquee = isMatchingRoute(pathname, layoutConfig.showPromoMarquee);
  // Home gets the bar too, but only once logged in (the other pages show it
  // for everyone).
  const showBottomNav =
    isMatchingRoute(pathname, layoutConfig.showBottomNav) ||
    (pathname === '/' && isAuthenticated);

  useEffect(() => {
    return () => {
      if (isMyBetsModalOpen) {
        dispatch(closeMyBetsModal());
      }
    };
  }, [dispatch, isMyBetsModalOpen, pathname]);

  return (
    <div
      style={{ background: `url('/images/bg.webp')` }}
      className="grid h-[100dvh] w-full grid-cols-[1fr_minmax(0,30rem)_1fr] overflow-hidden !bg-cover !bg-top !bg-no-repeat"
    >
      <div className="flex items-center justify-center max-md:hidden">
        <img src="/images/logo-9winbet-v2.webp" alt="Logo" className="w-full max-w-xs" />
        {/* <img src="/images/logo.webp" alt="Logo" className="w-full max-w-xs" /> */}
      </div>

      <main
        data-app-scroll-container
        className="scrollbar-hidden relative col-start-2 col-end-2 overflow-x-hidden overflow-y-scroll bg-[#eef3f7]"
      >
        <Header />
        <DepositWithdrawBar />

        {showPromoMarquee && <PromoMarquee />}

        <div className="min-h-[100dvh] animate-fade-in">
          <Outlet />
        </div>

        <div className={'pb-28'}>
          <Footer />
        </div>
      </main>

      <FloatingMyBetsButton />
      {isMyBetsModalOpen && <MyBetsModal />}

      <MobileScrollTopButton />
      {showBottomNav && <BottomNav />}
    </div>
  );
}

export default AppLayoutWithBottomNav;
